// src/index.tsx
import { getChainConfig as getChainConfig2 } from "@web3auth/base";

// src/configs/openloginAdapterConfig.tsx
var getOpenloginAdapterConfig = (options) => {
  var _a3, _b, _c, _d, _e, _f, _g, _h, _i;
  const auth0 = options == null ? void 0 : options.auth0;
  const jwt = options == null ? void 0 : options.jwt;
  const signature = options == null ? void 0 : options.signature;
  const loginConfig = {
    twitch: {
      clientId: (_a3 = process.env.REACT_APP_ZEROKIT_TWITCH_CLIENT_ID) != null ? _a3 : "vidpa4wsenhzfy8h5qak0wznqckmjn",
      name: "Twitch",
      typeOfLogin: "twitch",
      "verifier": "zerokit-twitch"
    },
    google: {
      clientId: (_b = process.env.REACT_APP_ZEROKIT_GOOGLE_CLIENT_ID) != null ? _b : "858644905236-j3v174qpg83pt1nkhb861l9up8762gnh.apps.googleusercontent.com",
      name: "Google",
      typeOfLogin: "google",
      verifier: "zerokit-google"
    },
    facebook: {
      clientId: (_c = process.env.REACT_APP_ZEROKIT_FACEBOOK_CLIENT_ID) != null ? _c : "735339824616125",
      name: "Facebook",
      typeOfLogin: "facebook",
      verifier: "zerokit-facebook"
    },
    twitter: {
      clientId: (_d = process.env.REACT_APP_ZEROKIT_TWITTER_CLIENT_ID) != null ? _d : "bjt1MzABwIvAYl3oWYmffTqw1eKqP3sH",
      name: "Twitter",
      typeOfLogin: "twitter",
      verifier: "zerokit-twitter2",
      jwtParameters: {
        domain: (_e = process.env.REACT_APP_ZEROKIT_TWITTER_DOMAIN) != null ? _e : "https://zerokit.us.auth0.com",
        verifierIdField: "sub"
      }
    },
    github: {
      clientId: (_f = process.env.REACT_APP_ZEROKIT_GITHUB_CLIENT_ID) != null ? _f : "bjt1MzABwIvAYl3oWYmffTqw1eKqP3sH",
      name: "Github",
      typeOfLogin: "github",
      verifier: "zerokit-github",
      jwtParameters: {
        domain: (_g = process.env.REACT_APP_ZEROKIT_GITHUB_DOMAIN) != null ? _g : "https://zerokit.us.auth0.com",
        verifierIdField: "sub"
      }
    },
    discord: {
      clientId: (_h = process.env.REACT_APP_ZEROKIT_DISCORD_CLIENT_ID) != null ? _h : "1072625703675236412",
      name: "Discord",
      typeOfLogin: "discord",
      verifier: "zerokit-discord"
    }
  };
  if (auth0) {
    loginConfig["auth0"] = {
      typeOfLogin: "jwt",
      clientId: auth0.clientId,
      verifier: auth0.verifier
    };
  }
  if (jwt) {
    loginConfig["jwt"] = {
      typeOfLogin: "jwt",
      clientId: "random",
      verifier: jwt.verifier
    };
  }
  return {
    ...signature && window ? {
      originData: {
        [window.location.origin]: signature
      }
    } : {},
    loginConfig,
    network: (_i = process.env.REACT_APP_ZEROKIT_WEB3AUTH_NETWORK) != null ? _i : "cyan",
    ...options == null ? void 0 : options.adapterSettings
  };
};

// src/configs/chainConfig.tsx
import { CHAIN_NAMESPACES } from "@web3auth/base";

// src/constants.tsx
var HIDDEN_LOGIN_METHODS = [
  "reddit",
  "apple",
  "line",
  "kakao",
  "linkedin",
  "weibo",
  "wechat",
  "email_passwordless"
];
var _a;
var BACKEND_URL = (_a = process.env.REACT_APP_ZERODEV_BACKEND_URL) != null ? _a : "https://backend-vikp.onrender.com";
var INFURA_API_KEY = "f36f7f706a58477884ce6fe89165666c";
var CHAIN_ID_TO_NODE = {
  1: `https://mainnet.infura.io/v3/${INFURA_API_KEY}`,
  5: `https://goerli.infura.io/v3/${INFURA_API_KEY}`,
  11155111: "https://fittest-ultra-aura.ethereum-sepolia.quiknode.pro/3893d01b1dd411fdfa9b6dd372dd2b4f69fcf1ea/",
  137: `https://polygon-mainnet.infura.io/v3/${INFURA_API_KEY}`,
  80001: `https://polygon-mumbai.infura.io/v3/${INFURA_API_KEY}`,
  10: `https://optimism-mainnet.infura.io/v3/${INFURA_API_KEY}`,
  420: `https://optimism-goerli.infura.io/v3/${INFURA_API_KEY}`,
  42161: `https://arbitrum-mainnet.infura.io/v3/${INFURA_API_KEY}`,
  421613: `https://arbitrum-goerli.infura.io/v3/${INFURA_API_KEY}`,
  43114: `https://avalanche-mainnet.infura.io/v3/${INFURA_API_KEY}`,
  43113: `https://avalanche-fuji.infura.io/v3/${INFURA_API_KEY}`,
  1313161554: `https://aurora-mainnet.infura.io/v3/${INFURA_API_KEY}`,
  1313161555: `https://aurora-testnet.infura.io/v3/${INFURA_API_KEY}`,
  56: "https://neat-greatest-layer.bsc.quiknode.pro/9405a499ceee314e5f2f68c9d47518d3537fce6a/",
  8453: "https://twilight-red-tree.base-mainnet.quiknode.pro/dc6eb27bf0f917df215922488dd97f4de7d9b08e/",
  84531: "https://icy-long-mountain.base-goerli.quiknode.pro/5b80d93e97cc9412a63c10a30841869abbef9596/",
  100: "https://thrilling-fluent-film.xdai.quiknode.pro/305955cffb9868cdd95b5e3dc9775f20678ad9ac/",
  10200: "https://nd-810-853-201.p2pify.com/e828b09f0d43591de96c297b3f36fffd"
};
var _a2;
var ZERODEV_CLIENT_ID = (_a2 = process.env.REACT_APP_ZEROKIT_WEB3AUTH_CLIENT_ID) != null ? _a2 : "BEjNZMt6TPboj3TfHM06MP8Yxz7cKQX6eK3KZzVhrIMi7jALcZHxJv5o3fDLM7EL4QfPlf2AV_qe155vyR3QxiU";

// src/configs/chainConfig.tsx
var getChainConfig = (chainId) => ({
  chainNamespace: CHAIN_NAMESPACES.EIP155,
  chainId: `0x${chainId == null ? void 0 : chainId.toString(16)}`,
  rpcTarget: CHAIN_ID_TO_NODE[chainId]
});

// src/configs/web3AuthConfig.tsx
import { CHAIN_NAMESPACES as CHAIN_NAMESPACES2 } from "@web3auth/base";
var getWeb3AuthConfig = (chainId, web3authOptions) => {
  return {
    chainConfig: chainId ? getChainConfig(chainId) : {
      chainNamespace: CHAIN_NAMESPACES2.EIP155
    },
    clientId: ZERODEV_CLIENT_ID,
    enableLogging: false,
    ...web3authOptions != null ? web3authOptions : {}
  };
};

// src/ZeroDevWeb3AuthWithModal.ts
import { Web3Auth } from "@web3auth/modal";
import { ADAPTER_EVENTS, ADAPTER_STATUS, WALLET_ADAPTERS } from "@web3auth/base";
import { OpenloginAdapter } from "@web3auth/openlogin-adapter";

// src/utilities.ts
function isMobileDevice() {
  if (typeof window === "undefined" || !window.navigator)
    return false;
  const userAgent = navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(userAgent);
}
var projectConfigurationCache = {};
var getProjectsConfiguration = async (projectIds, backendUrl) => {
  const projectIdsKey = projectIds.join("-");
  if (projectConfigurationCache[projectIdsKey] === void 0) {
    projectConfigurationCache[projectIdsKey] = new Promise((resolve, reject) => {
      fetch(
        `${backendUrl != null ? backendUrl : BACKEND_URL}/v1/projects/get`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            projectIds: projectIds.map((projectId) => projectId.toString())
          })
        }
      ).then((resp) => {
        resp.json().then(resolve).catch(reject);
      }).catch(reject);
    });
  }
  return await projectConfigurationCache[projectIdsKey];
};

// src/ZeroDevWeb3AuthWithModal.ts
var proxyHandler = {
  instance: null,
  construct(target, [projectIds, chainId, options]) {
    if (!this.instance) {
      const instance = Reflect.construct(target, [getWeb3AuthConfig(chainId, options == null ? void 0 : options.web3authOptions)]);
      let initiated = false;
      this.instance = new Proxy(instance, {
        get(target2, property, receiver) {
          if (property === "init") {
            if (initiated) {
              return async function(initOptions) {
                if (initOptions == null ? void 0 : initOptions.onConnect) {
                  instance.on(ADAPTER_EVENTS.CONNECTED, (data) => {
                    instance.getUserInfo().then(initOptions.onConnect);
                  });
                }
              };
            }
            initiated = true;
            return async function(initOptions) {
              var _a3, _b, _c;
              let openLoginAdapterSettings = {
                uxMode: isMobileDevice() ? "redirect" : "popup",
                whiteLabel: {
                  name: "ZeroDev"
                },
                ...(_a3 = options == null ? void 0 : options.adapterSettings) != null ? _a3 : {}
              };
              if (!((_b = options == null ? void 0 : options.web3authOptions) == null ? void 0 : _b.clientId) || options.web3authOptions.clientId === ZERODEV_CLIENT_ID) {
                const { signature } = await getProjectsConfiguration(projectIds);
                openLoginAdapterSettings = getOpenloginAdapterConfig({
                  signature: ((_c = options == null ? void 0 : options.web3authOptions) == null ? void 0 : _c.clientId) ? void 0 : signature,
                  adapterSettings: options == null ? void 0 : options.adapterSettings
                });
              }
              const openLoginAdapter = new OpenloginAdapter({ adapterSettings: openLoginAdapterSettings });
              instance.configureAdapter(openLoginAdapter);
              if (initOptions == null ? void 0 : initOptions.onConnect) {
                instance.on(ADAPTER_EVENTS.CONNECTED, (data) => {
                  instance.getUserInfo().then(initOptions.onConnect);
                });
              }
              if (instance.status === ADAPTER_STATUS.NOT_READY) {
                initiated = Reflect.get(target2, "initModal").apply(this, [{
                  modalConfig: {
                    [WALLET_ADAPTERS.OPENLOGIN]: {
                      label: "openlogin",
                      loginMethods: {
                        ...HIDDEN_LOGIN_METHODS.reduce((hiddenLoginLoginConfig, hiddenLoginMethod) => ({ ...hiddenLoginLoginConfig, [hiddenLoginMethod]: { typeOfLogin: hiddenLoginMethod, showOnModal: false } }), {})
                      }
                    }
                  }
                }]);
              }
            };
          }
          if (property === "connect") {
            return async function() {
              if (instance.status === "connecting") {
                instance.status = "ready";
                instance.walletAdapters[WALLET_ADAPTERS.OPENLOGIN].status = "ready";
              }
              for (let i = 1; i <= 5; i++) {
                if (initiated instanceof Promise) {
                  await initiated;
                  break;
                }
                await new Promise((resolve) => setTimeout(resolve, 5e3 / 5));
              }
              if (instance.status !== "connected") {
                return Reflect.get(target2, property).apply(this);
              }
              return instance.provider;
            };
          }
          return Reflect.get(target2, property);
        }
      });
    }
    return this.instance;
  }
};
var ZeroDevWeb3AuthWithModal = new Proxy(Web3Auth, proxyHandler);
var ZeroDevWeb3AuthWithModal_default = ZeroDevWeb3AuthWithModal;

// src/ZeroDevWeb3Auth.ts
import { Web3AuthNoModal } from "@web3auth/no-modal";
import { ADAPTER_EVENTS as ADAPTER_EVENTS2, ADAPTER_STATUS as ADAPTER_STATUS2, WALLET_ADAPTERS as WALLET_ADAPTERS2 } from "@web3auth/base";
import { OpenloginAdapter as OpenloginAdapter2 } from "@web3auth/openlogin-adapter";
var getAuth0Data = (items) => {
  const item = items == null ? void 0 : items.find((item2) => item2.provider === "auth0");
  return item ? { verifier: item.verifierId, clientId: item.config.auth0ClientId, domain: item.config.auth0Url } : {};
};
var getJWTData = (items) => {
  const item = items == null ? void 0 : items.find((item2) => item2.provider === "jwt");
  return item ? { verifier: item.verifierId, jwtField: item.config.jwtField } : {};
};
var proxyHandler2 = {
  instance: null,
  construct(target, [projectIds, chainId, options]) {
    if (!this.instance) {
      const eventHandlers = { onConnect: {} };
      const instance = Reflect.construct(target, [getWeb3AuthConfig(chainId, options == null ? void 0 : options.web3authOptions)]);
      let initiated = false;
      let authenticationProviders;
      this.instance = new Proxy(instance, {
        get(target2, property, receiver) {
          if (property === "init") {
            if (initiated) {
              return async function(loginProvider, initOptions) {
                if (initOptions == null ? void 0 : initOptions.onConnect) {
                  if (eventHandlers.onConnect[loginProvider]) {
                    instance.removeListener(ADAPTER_EVENTS2.CONNECTED, eventHandlers["onConnect"][loginProvider]);
                  }
                  eventHandlers.onConnect[loginProvider] = () => {
                    instance.getUserInfo().then(initOptions.onConnect);
                  };
                  instance.on(ADAPTER_EVENTS2.CONNECTED, eventHandlers.onConnect[loginProvider]);
                }
              };
            }
            initiated = true;
            return async function(initOptions) {
              var _a3, _b, _c;
              let openLoginAdapterSettings = {
                uxMode: isMobileDevice() ? "redirect" : "popup",
                whiteLabel: {
                  name: "ZeroDev"
                },
                ...(_a3 = options == null ? void 0 : options.adapterSettings) != null ? _a3 : {}
              };
              if (!((_b = options == null ? void 0 : options.web3authOptions) == null ? void 0 : _b.clientId) || options.web3authOptions.clientId === ZERODEV_CLIENT_ID) {
                const data = await getProjectsConfiguration(projectIds);
                authenticationProviders = data.authenticationProviders;
                openLoginAdapterSettings = getOpenloginAdapterConfig({
                  signature: ((_c = options == null ? void 0 : options.web3authOptions) == null ? void 0 : _c.clientId) ? void 0 : data.signature,
                  jwt: getJWTData(authenticationProviders),
                  auth0: getAuth0Data(authenticationProviders),
                  adapterSettings: options == null ? void 0 : options.adapterSettings
                });
              }
              const openLoginAdapter = new OpenloginAdapter2({ adapterSettings: openLoginAdapterSettings });
              instance.configureAdapter(openLoginAdapter);
              if (initOptions == null ? void 0 : initOptions.onConnect) {
                instance.on(ADAPTER_EVENTS2.CONNECTED, (data) => {
                  instance.getUserInfo().then(initOptions.onConnect);
                });
              }
              if (instance.status === ADAPTER_STATUS2.NOT_READY) {
                initiated = Reflect.get(target2, property).apply(this);
              }
            };
          }
          if (property === "connect") {
            return async function(loginProvider, extra) {
              if (instance.status === "connecting") {
                instance.status = "ready";
                instance.walletAdapters[WALLET_ADAPTERS2.OPENLOGIN].status = "ready";
              }
              for (let i = 1; i <= 5; i++) {
                if (initiated instanceof Promise) {
                  await initiated;
                  break;
                }
                await new Promise((resolve) => setTimeout(resolve, 5e3 / 5));
              }
              if (instance.status !== "connected") {
                const jwtOptions = {};
                if (loginProvider === "jwt") {
                  jwtOptions["extraLoginOptions"] = {
                    verifierIdField: getJWTData(authenticationProviders).jwtField,
                    id_token: extra == null ? void 0 : extra.jwt
                  };
                }
                if (loginProvider === "auth0") {
                  jwtOptions["extraLoginOptions"] = {
                    verifierIdField: "name",
                    domain: getAuth0Data(authenticationProviders).domain
                  };
                }
                return Reflect.get(target2, "connectTo").apply(this, [WALLET_ADAPTERS2.OPENLOGIN, {
                  loginProvider,
                  ...jwtOptions
                }]);
              }
              return instance.provider;
            };
          }
          return Reflect.get(target2, property);
        }
      });
    }
    return this.instance;
  }
};
var ZeroDevWeb3Auth = new Proxy(Web3AuthNoModal, proxyHandler2);
var ZeroDevWeb3Auth_default = ZeroDevWeb3Auth;
export {
  ZeroDevWeb3Auth_default as ZeroDevWeb3Auth,
  ZeroDevWeb3AuthWithModal_default as ZeroDevWeb3AuthWithModal,
  getChainConfig2 as getChainConfig,
  getOpenloginAdapterConfig,
  getProjectsConfiguration,
  getWeb3AuthConfig
};
